import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import {useRoute} from 'vue-router';
import {getQuotationOfWantToBuyList, adoptQuotation, refuseQuotation, getQuotationTel} from '@/api/miscellaneous';
import moment from 'moment';
import RestrictDialog from '@/components/RestrictDialog.vue';
import VipTag from '@/components/VipTag.vue';
import {ImagePreview} from 'vant';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuotationOfWantToBuy',
  setup(__props, { expose }) {
  expose();

const {query} = useRoute();
const getListData = ref({
    page: 1,
    size: 10,
    id: ((query.id || query.state) as string) || '',
});
const list = ref<any[]>([]);
const loading = ref(false);
const finished = ref(false);

const restrictShow = ref(false);
const restrictCode = ref('');
const tel = ref('');
const isShowTel = ref(false);

const isShowVideo = ref(false);
const videoUrl = ref('');

const getList = () => {
    if (loading.value) return;
    loading.value = true;
    getQuotationOfWantToBuyList(getListData.value).then((res: any) => {
        loading.value = false;
        list.value = [...list.value, ...res.items];
        getListData.value.page++;
        finished.value = res.count == 0 ? true : getListData.value.page * getListData.value.size > res.totalCount;
    });
};
getList();

const adopt = (id: string) => {
    console.log(id, '--id');
    adoptQuotation({id}).then(() => {
        getList();
    });
};
const refuse = (id: string) => {
    refuseQuotation({id}).then(() => {
        getList();
    });
};

const getTel = (id: string): void => {
    getQuotationTel({id})
        .then(res => {
            console.log(res, '--res');
            tel.value = res as string;
            isShowTel.value = true;
        })
        .catch(e => {
            let {code} = e;
            if ([121, 122].includes(code)) {
                restrictCode.value = code;
                restrictShow.value = true;
            }
        });
};

const playVideo = (data: string) => {
    isShowVideo.value = true;
    videoUrl.value = data;
};

const stateClass = (item: any) => {
    return [
        {
            'state-ignore': Reflect.has(item, 'isAccept') && !item.isAccept,
            'state-Adopt': Reflect.has(item, 'isAccept') && item.isAccept,
        },
    ];
};

const showImage = (data: any, idx: number) => {
    ImagePreview({
        images: data.photos,
        startPosition: idx,
    });
};

const __returned__ = { query, getListData, list, loading, finished, restrictShow, restrictCode, tel, isShowTel, isShowVideo, videoUrl, getList, adopt, refuse, getTel, playVideo, stateClass, showImage, ref, useRoute, getQuotationOfWantToBuyList, adoptQuotation, refuseQuotation, getQuotationTel, moment, RestrictDialog, VipTag, ImagePreview }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})